module.exports = __webpack_public_path__ + "static/media/1.d9fb5614.svg";